import {BaseMuWidget} from "../BaseMuWidget";

export class CalendarOverview extends BaseMuWidget {
	public firstDayInWeek: number = 1;
	public dayNames = [ "Po", "Ut", "St", "Čt", "Pa", "So", "Ne" ];
	public itemParams: Record<string, any> = { };
	private currentYear: number = -1;
	private currentMonth: number = -1;
	beforeIndex() {
		this.muRegisterEvent('add');
		this.container.classList.add('calendar-overview', 'calendar-overview--grid');
		this.muAppendContent(`
			<div class="calendar-overview__content" mu="content">
				<div mu=":CalendarOverviewDay@day"></div>
				<div class="calendar-overview__weekday" mu=":.@weekDay"><span mu-bind="name"></span></div>
			</div>
		`);
	}

	afterIndex() {
		// this.makeDays(2024, 1);
	}

	public dayWidgets: Record<number, CalendarOverviewDay> = {};

	protected makeDays(y: number, m: number) {
		this.currentMonth = m;
		this.currentYear = y;

		const lastDayNum = new Date(y, m + 1, 0).getDate();
		const firstDay = new Date(y, m);

		const fdc = (firstDay.getDay() - this.firstDayInWeek + 7) % 7;

		for(const name of this.dayNames)
			this.muWidgetFromTemplate('weekDay', 'content').muBindData({ name });

		for(let i = 0; i < fdc; i++) this.muWidgetFromTemplate('day', 'content', {
			otherMonthDay: true
		});
		this.dayWidgets = {};
		for(let d = 1; d <= lastDayNum; d++) {
			const dt = new Date(firstDay);
			dt.setDate(d);
			this.dayWidgets[d] = this.muWidgetFromTemplate('day', 'content', {
				otherMonthDay: false,
				dayNum: d,
				date: dt
			}) as unknown as CalendarOverviewDay;
		}
	}

	bindData(y: number, m: number, data: any[] = []) {
		this.ui.content.innerHTML = '';
		this.makeDays(y, m);
		for(const item of data) {
			let dt = new Date(item[this.opts.dateFromField]);
			const dtFrom = new Date(dt);
			const dtTo = new Date(item[this.opts.dateToField] ?? item[this.opts.dateFromField]);
			let f = true;
			const currPeriod = this.currentMonth + this.currentYear * 12;
			while (dt <= dtTo) {
				const itemPeriod = dt.getMonth() + dt.getFullYear() * 12;
				const dom = dt.getDate();
				dt.setDate(dt.getDate() + 1);
				if (itemPeriod < currPeriod) {
					f = false;
					continue;
				}
				const data: any = { ...item };
				let rangeType: CalendarOverviewRangeType;
				const isEnd = dt > dtTo;
				if (isEnd && f) rangeType = "full";
				else if (f) rangeType = "begin";
				else if (isEnd) rangeType = "end";
				else rangeType = "mid";
				data[this.opts.rangeTypeField] = rangeType;
				f = false;

				if (itemPeriod > currPeriod) break;
				if (!this.dayWidgets[dom]) continue;
				const w = this.muWidgetFromTemplate('item', this.dayWidgets[dom].ui.items, this.itemParams);
				// @ts-ignore
				w.item = item;
				w.muBindData(data);
			}
		}
	}

	opts: CalendarOverviewOpts = {
		dateFromField: "dtFrom",
		dateToField: "dtTo",
		rangeTypeField: "rangeType",
	}
}

export type CalendarOverviewOpts = {
	dateFromField: string,
	dateToField: string,
	rangeTypeField: string,
}

export type CalendarOverviewRangeType = "begin"|"end"|"mid"|"full";

export class CalendarOverviewDay extends BaseMuWidget {

	public otherMonthDay: boolean = false;

	public dayNum: number|null = null;

	// @ts-ignore
	public date: Date;

	beforeIndex() {
		this.container.classList.add(`calendar-overview__day`);
		this.container.classList.toggle(`calendar-overview__day--empty-fill`, this.otherMonthDay);
		this.muAppendContent(`
			<span class="calendar-overview__day-date" mu="dayLabel">#</span>
			<div mu="items">
				<div mu=":CalendarOverviewItem@item">
				
				</div>
			</div>
			<span class="calendar-overview__day__add icon-before-add" mu="add">Přidat</span>			
		`);
	}

	afterIndex() {
		/* if (!this.otherMonthDay) {
			for(let n = 0; n < Math.random() * 8; n++) {
				this.muWidgetFromTemplate('item', 'items').muBindData({ name: "ggggg"});
			}
		} */
		// @ts-ignore
		this.ui.dayLabel.innerText = this.dayNum ?? "";
	}

	add_click() {
		this.muParent.muDispatchEvent('add', this.date);
	}
}

export class CalendarOverviewItem extends BaseMuWidget {
	beforeIndex() {
		this.container.classList.add(`calendar-overview__item`);
		this.muAppendContent(`<span mu="#name"></span>`)
	}

	muBindData(srcData: any) {
		super.muBindData(srcData);
		this.container.classList.add('calendar-overview__item--' + srcData.rangeType);
		this.container.classList.toggle('calendar-overview__item--repeating', !!srcData.repeat);
	}
}